const destinations = [
  {
    name: '',
    label: 'Select a destination',
  },
  {
    name: 'messenger',
    label: 'Messenger',
  },
  {
    name: 'website',
    label: 'Web',
  },
  {
    name: 'app',
    label: 'App',
  },
];

export default destinations;
